(function () {
  'use strict';

  var STORAGE_KEY = 'vda:wishlist:v1';
  var ACCOUNT_SYNC_ENDPOINT = '/apps/vda-wishlist';
  var ACCOUNT_SYNC_STATE_KEY = 'vda:wishlist:account-sync:v4';
  var OPERATION_PREFIX = 'vda:wishlist:account-op:v4:';
  var LEGACY_V3_ACCOUNT_SYNC_STATE_KEY = 'vda:wishlist:account-sync:v3';
  var LEGACY_V3_OPERATION_PREFIX = 'vda:wishlist:account-op:v3:';
  var LEGACY_V2_ACCOUNT_SYNC_STATE_KEY = 'vda:wishlist:account-sync:v2';
  var LEGACY_ACCOUNT_SYNC_STATE_KEY = 'vda:wishlist:account-sync:v1';
  var PENDING_AUTH_TARGET_PREFIX = '__pending_auth__:';
  var LEGACY_PENDING_AUTH_TARGET = '__pending_auth__';
  var AUTH_TRANSITION_SESSION_KEY = 'vda:wishlist:auth-transition:v1';
  var ACCOUNT_CACHE_PREFIX = 'vda:wishlist:account-cache:v2:';
  var LEGACY_ACCOUNT_CACHE_PREFIX = 'vda:wishlist:account-cache:v1:';
  var LEGACY_ACCOUNT_COOKIE_NAME = 'vda_wishlist_account';
  var authTransitionToken = null;
  var REQUEST_TIMEOUT_MS = 7000;
  var RETRY_DELAYS = [2000, 5000, 15000, 30000, 60000];
  var MAX_POST_OPERATIONS = 50;
  var memoryList = [];
  var localRevision = 0;
  var operationSequence = 0;
  var authMeta = document.querySelector('meta[name="vda-customer-auth"]');
  var fingerprintMeta = document.querySelector('meta[name="vda-customer-fingerprint"]');
  var customerHint = !!authMeta && authMeta.content === '1';
  var customerFingerprint = fingerprintMeta
    ? String(fingerprintMeta.content || '').trim()
    : '';
  var accountSync = {
    authenticated: false,
    accountKey: null,
    inFlight: false,
    queued: false,
    timer: null,
    retryTimer: null,
    retryCount: 0,
    lastSyncAt: 0,
    serverRevision: 0,
    resolvingIdentity: customerHint
  };
  var enhanceQueued = false;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path></svg>';

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function productHandle(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      var match = parsed.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (e) {
      return '';
    }
  }

  function itemKey(item) {
    return item && (item.handle || item.id || item.url) || '';
  }

  function normalizeItem(item) {
    item = item || {};
    var suppliedHandle = cleanText(item.handle).toLowerCase();
    var sourceUrl = item.url || '';
    var handle = suppliedHandle || productHandle(sourceUrl);

    if (!handle && sourceUrl) handle = productHandle(sourceUrl);
    if (!handle) {
      return {
        id: cleanText(item.id),
        handle: '',
        url: sourceUrl || '',
        title: cleanText(item.title) || 'Vintage piece',
        image: item.image || '',
        price: cleanText(item.price),
        vendor: cleanText(item.vendor)
      };
    }

    return {
      id: cleanText(item.id),
      handle: handle,
      url: '/products/' + encodeURIComponent(handle),
      title: cleanText(item.title) || 'Vintage piece',
      image: item.image || '',
      price: cleanText(item.price),
      vendor: cleanText(item.vendor)
    };
  }

  function normalizeList(items) {
    if (!Array.isArray(items)) return [];
    var seen = new Set();

    return items.map(function (item) {
      return normalizeItem(item || {});
    }).filter(function (item) {
      var key = itemKey(item);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return memoryList.slice();
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return normalizeList(parsed);
    } catch (e) {
      return memoryList.slice();
    }
  }

  function storeList(items) {
    items = normalizeList(items);
    memoryList = items.slice();

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function makeOperationId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    operationSequence += 1;
    return Date.now().toString(36) + '-' + operationSequence.toString(36) + '-' +
      Math.random().toString(36).slice(2, 10);
  }

  function normalizePendingOperation(operation) {
    if (!operation || typeof operation !== 'object') return null;

    var op =
      operation.op === 'remove'
        ? 'remove'
        : operation.op === 'update'
          ? 'update'
          : operation.op === 'add'
            ? 'add'
            : '';

    var id = cleanText(operation.id);
    var target = operation.target == null ? null : cleanText(operation.target);
    var key = cleanText(operation.key).toLowerCase();
    var baseRevision = Math.max(0, Number(operation.baseRevision) || 0);

    if (!op || !id || !key) return null;

    if (op === 'add' || op === 'update') {
      var item = normalizeItem(operation.item || {});
      if (!itemKey(item)) return null;
      key = itemKey(item);

      return {
        id: id,
        op: op,
        key: key,
        item: item,
        target: target,
        baseRevision: baseRevision,
        at: Number(operation.at) || Date.now()
      };
    }

    return {
      id: id,
      op: 'remove',
      key: key,
      target: target,
      baseRevision: baseRevision,
      at: Number(operation.at) || Date.now()
    };
  }

  function operationStorageKey(id) {
    return OPERATION_PREFIX + id;
  }

  function storeOperation(operation) {
    var normalized = normalizePendingOperation(operation);
    if (!normalized) return null;

    try {
      window.localStorage.setItem(
        operationStorageKey(normalized.id),
        JSON.stringify(normalized)
      );
    } catch (e) {}

    return normalized;
  }

  function removeOperation(id) {
    try {
      window.localStorage.removeItem(operationStorageKey(id));
    } catch (e) {}
  }

  function readOperationJournal() {
    var operations = [];

    try {
      for (var index = 0; index < window.localStorage.length; index += 1) {
        var key = window.localStorage.key(index);
        if (!key || key.indexOf(OPERATION_PREFIX) !== 0) continue;

        try {
          var raw = window.localStorage.getItem(key);
          var operation = normalizePendingOperation(JSON.parse(raw));
          if (operation) operations.push(operation);
        } catch (e) {}
      }
    } catch (e) {}

    operations.sort(function (a, b) {
      if (a.at !== b.at) return a.at - b.at;
      return a.id.localeCompare(b.id);
    });

    return operations;
  }

  function emptySyncState() {
    return {
      schema: 4,
      lastAccountKey: null,
      lastFingerprint: null
    };
  }

  function writeMigratedOperation(operation) {
    var normalized = normalizePendingOperation(operation);
    if (!normalized) return;
    storeOperation(normalized);
  }

  function migrateOldOperationPrefix(prefix) {
    var keys = [];

    try {
      for (var index = 0; index < window.localStorage.length; index += 1) {
        var key = window.localStorage.key(index);
        if (key && key.indexOf(prefix) === 0) keys.push(key);
      }

      keys.forEach(function (key) {
        try {
          var raw = window.localStorage.getItem(key);
          var operation = JSON.parse(raw);
          if (operation && typeof operation === 'object') {
            if (operation.baseRevision == null) operation.baseRevision = 0;
            writeMigratedOperation(operation);
          }
          window.localStorage.removeItem(key);
        } catch (e) {}
      });
    } catch (e) {}
  }

  function migrateSyncState() {
    var state = emptySyncState();
    var currentItems = readList();
    var legacyV3 = null;
    var legacyV2 = null;
    var legacyV1 = null;

    migrateOldOperationPrefix(LEGACY_V3_OPERATION_PREFIX);

    try {
      var rawV3 = window.localStorage.getItem(LEGACY_V3_ACCOUNT_SYNC_STATE_KEY);
      legacyV3 = rawV3 ? JSON.parse(rawV3) : null;
    } catch (e) {
      legacyV3 = null;
    }

    if (legacyV3 && typeof legacyV3 === 'object' && legacyV3.schema === 3) {
      state.lastAccountKey = legacyV3.lastAccountKey
        ? cleanText(legacyV3.lastAccountKey)
        : null;
    } else {
      try {
        var rawV2 = window.localStorage.getItem(LEGACY_V2_ACCOUNT_SYNC_STATE_KEY);
        legacyV2 = rawV2 ? JSON.parse(rawV2) : null;
      } catch (e) {
        legacyV2 = null;
      }

      if (legacyV2 && typeof legacyV2 === 'object' && legacyV2.schema === 2) {
        state.lastAccountKey = legacyV2.lastAccountKey
          ? cleanText(legacyV2.lastAccountKey)
          : null;

        (legacyV2.pending || []).forEach(function (operation) {
          if (operation && operation.baseRevision == null) {
            operation.baseRevision = 0;
          }
          writeMigratedOperation(operation);
        });
      } else {
        try {
          var rawV1 = window.localStorage.getItem(LEGACY_ACCOUNT_SYNC_STATE_KEY);
          legacyV1 = rawV1 ? JSON.parse(rawV1) : null;
        } catch (e) {
          legacyV1 = null;
        }

        if (legacyV1 && typeof legacyV1 === 'object' && legacyV1.accountKey) {
          state.lastAccountKey = cleanText(legacyV1.accountKey) || null;

          var baseline = normalizeList(legacyV1.items);
          var baselineMap = new Map(baseline.map(function (item) {
            return [itemKey(item), item];
          }));
          var currentMap = new Map(currentItems.map(function (item) {
            return [itemKey(item), item];
          }));

          currentItems.forEach(function (item) {
            var key = itemKey(item);
            if (!baselineMap.has(key)) {
              writeMigratedOperation({
                id: makeOperationId(),
                op: 'add',
                key: key,
                item: item,
                target: null,
                baseRevision: 0,
                at: Date.now()
              });
            }
          });

          baseline.forEach(function (item) {
            var key = itemKey(item);
            if (!currentMap.has(key)) {
              writeMigratedOperation({
                id: makeOperationId(),
                op: 'remove',
                key: key,
                target: null,
                baseRevision: 0,
                at: Date.now()
              });
            }
          });
        } else {
          currentItems.forEach(function (item) {
            writeMigratedOperation({
              id: makeOperationId(),
              op: 'add',
              key: itemKey(item),
              item: item,
              target: null,
              baseRevision: 0,
              at: Date.now()
            });
          });
        }
      }
    }

    try {
      window.localStorage.setItem(ACCOUNT_SYNC_STATE_KEY, JSON.stringify(state));
      window.localStorage.removeItem(LEGACY_V3_ACCOUNT_SYNC_STATE_KEY);
      window.localStorage.removeItem(LEGACY_V2_ACCOUNT_SYNC_STATE_KEY);
      window.localStorage.removeItem(LEGACY_ACCOUNT_SYNC_STATE_KEY);
    } catch (e) {}

    return state;
  }

  function readSyncState() {
    try {
      var raw = window.localStorage.getItem(ACCOUNT_SYNC_STATE_KEY);
      if (!raw) return migrateSyncState();

      var parsed = JSON.parse(raw);
      if (!parsed || parsed.schema !== 4) return migrateSyncState();

      return {
        schema: 4,
        lastAccountKey: parsed.lastAccountKey
          ? cleanText(parsed.lastAccountKey)
          : null,
        lastFingerprint: parsed.lastFingerprint
          ? cleanText(parsed.lastFingerprint)
          : null
      };
    } catch (e) {
      return migrateSyncState();
    }
  }

  function writeSyncState(state) {
    var normalized = {
      schema: 4,
      lastAccountKey:
        state && state.lastAccountKey
          ? cleanText(state.lastAccountKey)
          : null,
      lastFingerprint:
        state && state.lastFingerprint
          ? cleanText(state.lastFingerprint)
          : null
    };

    try {
      window.localStorage.setItem(
        ACCOUNT_SYNC_STATE_KEY,
        JSON.stringify(normalized)
      );
    } catch (e) {}

    return normalized;
  }

  function makeTransitionToken() {
    return makeOperationId();
  }

  function pendingTargetPrefixForFingerprint(fingerprint) {
    if (!fingerprint) return null;
    return PENDING_AUTH_TARGET_PREFIX + fingerprint + ':';
  }

  function pendingTargetFingerprint(target) {
    if (
      typeof target !== 'string' ||
      target.indexOf(PENDING_AUTH_TARGET_PREFIX) !== 0 ||
      target === LEGACY_PENDING_AUTH_TARGET
    ) {
      return null;
    }

    var remainder = target.slice(PENDING_AUTH_TARGET_PREFIX.length);
    var separator = remainder.indexOf(':');
    if (separator === -1) return null;
    return remainder.slice(0, separator) || null;
  }

  function existingPendingAuthTarget() {
    if (!customerFingerprint) return null;

    var stored = null;

    try {
      stored = window.sessionStorage.getItem(
        AUTH_TRANSITION_SESSION_KEY
      );
    } catch (e) {
      stored = null;
    }

    if (stored) {
      try {
        var parsed = JSON.parse(stored);
        if (
          parsed &&
          parsed.fingerprint === customerFingerprint &&
          parsed.token
        ) {
          authTransitionToken = cleanText(parsed.token);
        } else {
          authTransitionToken = null;
        }
      } catch (e) {
        authTransitionToken = null;
      }
    }

    return authTransitionToken
      ? pendingTargetPrefixForFingerprint(customerFingerprint) +
          authTransitionToken
      : null;
  }

  function currentPendingAuthTarget() {
    var existing = existingPendingAuthTarget();
    if (existing) return existing;

    if (!customerHint || !customerFingerprint) return null;

    authTransitionToken = makeTransitionToken();

    try {
      window.sessionStorage.setItem(
        AUTH_TRANSITION_SESSION_KEY,
        JSON.stringify({
          fingerprint: customerFingerprint,
          token: authTransitionToken
        })
      );
    } catch (e) {}

    return (
      pendingTargetPrefixForFingerprint(customerFingerprint) +
      authTransitionToken
    );
  }

  function isPendingAuthTarget(target) {
    return (
      target === LEGACY_PENDING_AUTH_TARGET ||
      (typeof target === 'string' &&
       target.indexOf(PENDING_AUTH_TARGET_PREFIX) === 0)
    );
  }

  function migrateLegacyPendingAuthOperations() {
    readOperationJournal().forEach(function (operation) {
      if (
        typeof operation.target === 'string' &&
        operation.target.indexOf(PENDING_AUTH_TARGET_PREFIX) === 0 &&
        operation.target !== LEGACY_PENDING_AUTH_TARGET &&
        !pendingTargetFingerprint(operation.target)
      ) {
        operation.target = null;
        operation.baseRevision = 0;
        storeOperation(operation);
      }
    });
  }

  function pendingBelongsToFingerprint(target, fingerprint) {
    if (!fingerprint) return false;
    return pendingTargetFingerprint(target) === fingerprint;
  }

  function purgeLegacyAccountCaches() {
    var keys = [];

    try {
      for (var index = 0; index < window.localStorage.length; index += 1) {
        var key = window.localStorage.key(index);
        if (
          key &&
          key.indexOf(LEGACY_ACCOUNT_CACHE_PREFIX) === 0
        ) {
          keys.push(key);
        }
      }

      keys.forEach(function (key) {
        window.localStorage.removeItem(key);
      });
    } catch (e) {}
  }

  function deleteLegacyAccountCookie() {
    try {
      document.cookie =
        LEGACY_ACCOUNT_COOKIE_NAME +
        '=; Path=/; SameSite=Lax; Secure; Max-Age=0';
    } catch (e) {}
  }

  function readAccountCache(fingerprint) {
    if (!fingerprint) return null;

    try {
      var raw = window.localStorage.getItem(
        ACCOUNT_CACHE_PREFIX + fingerprint
      );
      if (!raw) return null;

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;

      var accountKey = cleanText(parsed.accountKey);
      if (!accountKey) return null;

      return {
        accountKey: accountKey,
        revision: Math.max(0, Number(parsed.revision) || 0),
        items: normalizeList(parsed.items)
      };
    } catch (e) {
      return null;
    }
  }

  function writeAccountCache(fingerprint, accountKey, revision, items) {
    if (!fingerprint || !accountKey) return;

    try {
      window.localStorage.setItem(
        ACCOUNT_CACHE_PREFIX + fingerprint,
        JSON.stringify({
          accountKey: accountKey,
          revision: Math.max(0, Number(revision) || 0),
          items: normalizeList(items)
        })
      );
    } catch (e) {}
  }

  function releasePendingForFingerprintToAnonymous(fingerprint) {
    if (!fingerprint) return;

    readOperationJournal().forEach(function (operation) {
      if (
        pendingBelongsToFingerprint(operation.target, fingerprint) ||
        operation.target === LEGACY_PENDING_AUTH_TARGET
      ) {
        operation.target = null;
        operation.baseRevision = 0;
        storeOperation(operation);
      }
    });

    try {
      var stored = window.sessionStorage.getItem(
        AUTH_TRANSITION_SESSION_KEY
      );

      if (stored) {
        try {
          var parsed = JSON.parse(stored);
          if (parsed && parsed.fingerprint === fingerprint) {
            window.sessionStorage.removeItem(
              AUTH_TRANSITION_SESSION_KEY
            );
          }
        } catch (e) {
          window.sessionStorage.removeItem(
            AUTH_TRANSITION_SESSION_KEY
          );
        }
      }
    } catch (e) {}

    if (fingerprint === customerFingerprint) {
      authTransitionToken = null;
    }
  }

  function targetForNewOperation() {
    if (
      customerHint &&
      customerFingerprint &&
      accountSync.authenticated &&
      accountSync.accountKey
    ) {
      return accountSync.accountKey;
    }

    if (customerHint) {
      return currentPendingAuthTarget();
    }

    return null;
  }

  function revisionForNewOperation(target) {
    if (
      target &&
      !isPendingAuthTarget(target) &&
      customerHint &&
      accountSync.authenticated &&
      accountSync.accountKey &&
      target === accountSync.accountKey
    ) {
      return accountSync.serverRevision;
    }

    if (
      target &&
      isPendingAuthTarget(target) &&
      customerHint &&
      customerFingerprint &&
      accountSync.accountKey
    ) {
      return accountSync.serverRevision;
    }

    return 0;
  }

  function recordOperation(op, itemOrKey) {
    var target = targetForNewOperation();
    var baseRevision = revisionForNewOperation(target);
    var operation;

    if (op === 'add' || op === 'update') {
      var item = normalizeItem(itemOrKey || {});
      var key = itemKey(item);
      if (!key) return;

      operation = {
        id: makeOperationId(),
        op: op,
        key: key,
        item: item,
        target: target,
        baseRevision: baseRevision,
        at: Date.now()
      };
    } else {
      var removeKey = cleanText(itemOrKey).toLowerCase();
      if (!removeKey) return;

      operation = {
        id: makeOperationId(),
        op: 'remove',
        key: removeKey,
        target: target,
        baseRevision: baseRevision,
        at: Date.now()
      };
    }

    storeOperation(operation);
    localRevision += 1;
    scheduleAccountSync(350);
  }

  function adoptUnscopedOperations(
    accountKey,
    serverRevision,
    previousAccountKey
  ) {
    readOperationJournal().forEach(function (operation) {
      if (operation.target === null) {
        operation.target = accountKey;
        operation.baseRevision = serverRevision;
        storeOperation(operation);
        return;
      }

      if (
        operation.target === LEGACY_PENDING_AUTH_TARGET ||
        pendingBelongsToFingerprint(
          operation.target,
          customerFingerprint
        )
      ) {
        operation.target = accountKey;
        storeOperation(operation);
        return;
      }

      if (
        previousAccountKey &&
        previousAccountKey !== accountKey &&
        operation.target === previousAccountKey
      ) {
        operation.target = accountKey;
        operation.baseRevision = serverRevision;
        storeOperation(operation);
      }
    });
  }

  function compactOperationsForAccount(accountKey) {
    var relevant = readOperationJournal().filter(function (operation) {
      return operation.target === accountKey;
    });

    relevant.sort(function (a, b) {
      if (a.at !== b.at) return a.at - b.at;
      return a.id.localeCompare(b.id);
    });

    var byKey = new Map();

    relevant.forEach(function (operation) {
      var previous = byKey.get(operation.key);

      if (!previous) {
        byKey.set(operation.key, operation);
        return;
      }

      var baseRevision = Math.min(
        previous.baseRevision || 0,
        operation.baseRevision || 0
      );

      if (previous.op === 'add' && operation.op === 'update') {
        previous.item = operation.item;
        previous.at = operation.at;
        previous.baseRevision = baseRevision;
        storeOperation(previous);
        removeOperation(operation.id);
        byKey.set(operation.key, previous);
        return;
      }

      if (previous.op === 'remove' && operation.op === 'update') {
        removeOperation(operation.id);
        byKey.set(operation.key, previous);
        return;
      }

      var next = Object.assign({}, operation, {
        baseRevision: baseRevision
      });

      if (
        previous.op === 'update' &&
        operation.op === 'update'
      ) {
        storeOperation(next);
        removeOperation(previous.id);
        byKey.set(operation.key, next);
        return;
      }

      if (
        previous.op === 'add' &&
        operation.op === 'add'
      ) {
        storeOperation(next);
        removeOperation(previous.id);
        byKey.set(operation.key, next);
        return;
      }

      if (
        previous.op === 'remove' &&
        operation.op === 'add'
      ) {
        storeOperation(next);
        removeOperation(previous.id);
        byKey.set(operation.key, next);
        return;
      }

      if (operation.op === 'remove') {
        storeOperation(next);
        removeOperation(previous.id);
        byKey.set(operation.key, next);
        return;
      }

      if (operation.op === 'add') {
        storeOperation(next);
        removeOperation(previous.id);
        byKey.set(operation.key, next);
        return;
      }

      storeOperation(next);
      removeOperation(previous.id);
      byKey.set(operation.key, next);
    });

    var compacted = Array.from(byKey.values());

    compacted.sort(function (a, b) {
      var aRank = a.op === 'remove' ? 0 : a.op === 'update' ? 1 : 2;
      var bRank = b.op === 'remove' ? 0 : b.op === 'update' ? 1 : 2;

      if (aRank !== bRank) return aRank - bRank;
      if (a.at !== b.at) return a.at - b.at;
      return a.id.localeCompare(b.id);
    });

    return compacted;
  }

  function applyOperationsToList(items, operations) {
    var next = normalizeList(items);

    (operations || []).forEach(function (operation) {
      if (operation.op === 'remove') {
        next = next.filter(function (item) {
          return itemKey(item) !== operation.key;
        });
        return;
      }

      if (operation.op === 'update' && operation.item) {
        var updateIndex = next.findIndex(function (item) {
          return itemKey(item) === operation.key;
        });

        if (updateIndex !== -1) {
          next[updateIndex] = normalizeItem(operation.item);
        }
        return;
      }

      if (operation.op === 'add' && operation.item) {
        var item = normalizeItem(operation.item);
        var key = itemKey(item);
        if (!key) return;

        next = next.filter(function (existing) {
          return itemKey(existing) !== key;
        });
        next.unshift(item);
      }
    });

    return next;
  }

  function listsEqual(left, right) {
    return JSON.stringify(normalizeList(left)) === JSON.stringify(normalizeList(right));
  }

  function applySyncedList(items) {
    items = normalizeList(items);

    if (!listsEqual(readList(), items)) {
      storeList(items);
      syncUi();
      renderDrawer();

      window.dispatchEvent(new CustomEvent('vda:wishlist:update', {
        detail: { count: items.length }
      }));
    }
  }

  function safeTransitionList() {
    var cache = readAccountCache(customerFingerprint);
    var baseItems = cache ? cache.items : [];
    var cachedAccountKey = cache ? cache.accountKey : null;

    if (cache) {
      accountSync.accountKey = cache.accountKey;
      accountSync.serverRevision = cache.revision;
    } else {
      accountSync.accountKey = null;
      accountSync.serverRevision = 0;
    }

    var pending = readOperationJournal().filter(function (operation) {
      return (
        operation.target === null ||
        operation.target === LEGACY_PENDING_AUTH_TARGET ||
        pendingBelongsToFingerprint(
          operation.target,
          customerFingerprint
        ) ||
        (cachedAccountKey &&
         operation.target === cachedAccountKey)
      );
    });

    return applyOperationsToList(baseItems, pending);
  }

  function prepareAnonymousView() {
    var state = readSyncState();

    if (state.lastFingerprint) {
      releasePendingForFingerprintToAnonymous(
        state.lastFingerprint
      );
    }

    state.lastFingerprint = null;
    state.lastAccountKey = null;
    writeSyncState(state);
    deleteLegacyAccountCookie();

    accountSync.accountKey = null;
    accountSync.serverRevision = 0;
    accountSync.authenticated = false;

    var anonymous = readOperationJournal().filter(function (operation) {
      return operation.target === null;
    });

    storeList(applyOperationsToList([], anonymous));
  }

  function prepareAuthenticatedTransition() {
    if (!customerHint) return;

    var state = readSyncState();
    state.lastFingerprint = customerFingerprint || null;
    writeSyncState(state);

    accountSync.resolvingIdentity = true;
    accountSync.authenticated = false;

    var safeList = safeTransitionList();
    storeList(safeList);
  }

  async function accountRequest(method, payload) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT_MS);

    var options = {
      method: method,
      credentials: 'same-origin',
      signal: controller.signal,
      headers: { 'Accept': 'application/json' }
    };

    if (method === 'POST') {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload || {});
    }

    try {
      var response = await fetch(ACCOUNT_SYNC_ENDPOINT, options);
      var data = await response.json().catch(function () { return {}; });

      if (!response.ok) {
        var error = new Error(data.error || 'Wishlist sync unavailable');
        error.status = response.status;
        error.code = data.code || 'wishlist_sync_failed';
        error.retryable =
          response.status === 408 ||
          response.status === 425 ||
          response.status === 429 ||
          response.status >= 500 ||
          error.code === 'concurrent_update';
        throw error;
      }

      return data;
    } catch (error) {
      if (error && error.name === 'AbortError') {
        error.retryable = true;
        error.code = 'timeout';
      } else if (typeof error.retryable !== 'boolean') {
        error.retryable = true;
      }

      throw error;
    } finally {
      window.clearTimeout(timer);
    }
  }

  function scheduleRetry(error) {
    if (!customerHint || (error && error.retryable === false)) return;
    if (accountSync.retryCount >= RETRY_DELAYS.length) return;

    var delay = RETRY_DELAYS[accountSync.retryCount];
    accountSync.retryCount += 1;

    window.clearTimeout(accountSync.retryTimer);
    accountSync.retryTimer = window.setTimeout(function () {
      syncAccountWishlist();
    }, delay);
  }

  function scheduleAccountSync(delay) {
    if (!customerHint) return;

    window.clearTimeout(accountSync.timer);
    accountSync.timer = window.setTimeout(function () {
      syncAccountWishlist();
    }, typeof delay === 'number' ? delay : 350);
  }

  function refreshVisibleSavedMetadata() {
    document.querySelectorAll('product-card[data-vda-wishlist-ready]').forEach(function (card) {
      var link = card.querySelector('a.product-card__link[href], a[href*="/products/"]');
      if (link) refreshSavedMetadata(makeItem(card, link));
    });

    document.querySelectorAll('a.vda-home2-product[data-vda-wishlist-ready]').forEach(function (link) {
      refreshSavedMetadata(makeItem(link, link));
    });

    document.querySelectorAll('.resource-card[data-resource-type="product"][data-vda-wishlist-ready]').forEach(function (card) {
      var link = card.querySelector('a.resource-card__link[href], a[href*="/products/"]');
      if (link) refreshSavedMetadata(makeItem(card, link));
    });

    if (productHandle(window.location.href)) {
      refreshSavedMetadata(productPageItem());
    }
  }

  async function syncAccountWishlist() {
    if (!customerHint) return;

    if (accountSync.inFlight) {
      accountSync.queued = true;
      return;
    }

    accountSync.inFlight = true;
    var cycleFailed = false;
    var cycleRevision = localRevision;

    try {
      var remote = await accountRequest('GET');

      if (!remote || !remote.authenticated || !remote.accountKey) {
        var authError = new Error('Customer session not available');
        authError.retryable = true;
        throw authError;
      }

      if (
        !customerFingerprint ||
        !remote.identityFingerprint ||
        String(remote.identityFingerprint) !== customerFingerprint
      ) {
        accountSync.authenticated = false;
        accountSync.accountKey = null;
        accountSync.serverRevision = 0;

        var localOnly = readOperationJournal().filter(function (operation) {
          return (
            operation.target === null ||
            pendingBelongsToFingerprint(
              operation.target,
              customerFingerprint
            )
          );
        });

        applySyncedList(applyOperationsToList([], localOnly));

        var identityError = new Error('Wishlist account identity changed');
        identityError.retryable = false;
        identityError.code = 'identity_mismatch';
        throw identityError;
      }

      var accountKey = String(remote.accountKey);
      var remoteRevision = Math.max(0, Number(remote.revision) || 0);
      var previousAccountKey = accountSync.accountKey;

      accountSync.authenticated = true;
      accountSync.resolvingIdentity = false;
      accountSync.accountKey = accountKey;
      accountSync.serverRevision = remoteRevision;

      adoptUnscopedOperations(
        accountKey,
        remoteRevision,
        previousAccountKey
      );

      var state = readSyncState();
      state.lastAccountKey = accountKey;
      state.lastFingerprint = customerFingerprint || null;
      writeSyncState(state);

      writeAccountCache(
        customerFingerprint,
        accountKey,
        remoteRevision,
        remote.items
      );

      var pending = compactOperationsForAccount(accountKey);
      var effective = applyOperationsToList(remote.items, pending);

      if (localRevision === cycleRevision) {
        applySyncedList(effective);
        refreshVisibleSavedMetadata();
      }

      if (pending.length) {
        var removals = pending.filter(function (operation) {
          return operation.op === 'remove';
        });
        var batch = (removals.length ? removals : pending)
          .slice(0, MAX_POST_OPERATIONS);
        var sentIds = new Set(batch.map(function (operation) {
          return operation.id;
        }));
        var postRevision = localRevision;

        var saved = await accountRequest('POST', {
          expectedIdentityFingerprint: customerFingerprint,
          expectedAccountKey: accountKey,
          operations: batch.map(function (operation) {
            return {
              id: operation.id,
              op: operation.op,
              key: operation.key,
              item: operation.item,
              baseRevision: operation.baseRevision
            };
          })
        });

        if (
          !saved ||
          !saved.authenticated ||
          saved.accountKey !== accountKey ||
          !saved.identityFingerprint ||
          String(saved.identityFingerprint) !== customerFingerprint
        ) {
          var mismatchError = new Error('Wishlist account changed during sync');
          mismatchError.retryable = true;
          throw mismatchError;
        }

        accountSync.serverRevision = Math.max(
          accountSync.serverRevision,
          Number(saved.revision) || 0
        );

        writeAccountCache(
          customerFingerprint,
          accountKey,
          accountSync.serverRevision,
          saved.items
        );

        var accepted = new Set(
          Array.isArray(saved.acceptedOperationIds)
            ? saved.acceptedOperationIds
            : Array.from(sentIds)
        );

        accepted.forEach(function (id) {
          removeOperation(id);
        });

        var remaining = compactOperationsForAccount(accountKey);
        var afterEffective = applyOperationsToList(saved.items, remaining);

        if (localRevision === postRevision) {
          applySyncedList(afterEffective);
          refreshVisibleSavedMetadata();
        }

        if (remaining.length) {
          accountSync.queued = true;
        }
      }

      accountSync.retryCount = 0;
      window.clearTimeout(accountSync.retryTimer);
      accountSync.lastSyncAt = Date.now();
    } catch (error) {
      cycleFailed = true;

      if (
        error &&
        (error.code === 'wishlist_item_limit' ||
         error.code === 'wishlist_storage_limit')
      ) {
        showToast('Saved on this device; account wishlist storage is full');
      } else {
        scheduleRetry(error);
      }
    } finally {
      accountSync.inFlight = false;

      if (accountSync.queued) {
        accountSync.queued = false;

        if (!cycleFailed) {
          window.setTimeout(syncAccountWishlist, 0);
        }
      }
    }
  }

  function writeList(items) {
    storeList(items);
    syncUi();
    renderDrawer();

    window.dispatchEvent(new CustomEvent('vda:wishlist:update', {
      detail: { count: items.length }
    }));
  }

  function refreshSavedMetadata(item) {
    item = normalizeItem(item);
    var key = itemKey(item);
    if (!key) return;

    var items = readList();
    var index = items.findIndex(function (saved) {
      return itemKey(saved) === key;
    });
    if (index === -1) return;

    var current = items[index];
    var next = Object.assign({}, current, {
      id: item.id || current.id,
      handle: item.handle || current.handle,
      url: item.url || current.url,
      title: item.title || current.title,
      image: item.image || current.image,
      price: item.price || current.price,
      vendor: item.vendor || current.vendor
    });

    if (JSON.stringify(current) !== JSON.stringify(next)) {
      items[index] = next;
      storeList(items);
      recordOperation('update', next);
    }
  }

  function toggleItem(item) {
    item = normalizeItem(item);
    var key = itemKey(item);
    if (!key) return;

    var items = readList();
    var index = items.findIndex(function (saved) {
      return itemKey(saved) === key;
    });
    var added = index === -1;

    if (added) {
      items.unshift(item);
      recordOperation('add', item);
    } else {
      items.splice(index, 1);
      recordOperation('remove', key);
    }

    writeList(items);
    showToast(added ? 'Saved to wishlist' : 'Removed from wishlist');
  }

  function removeItem(key) {
    key = cleanText(key).toLowerCase();
    if (!key) return;

    var items = readList().filter(function (item) {
      return itemKey(item) !== key;
    });

    recordOperation('remove', key);
    writeList(items);
    showToast('Removed from wishlist');
  }

  function imageFrom(root) {
    var image = root && root.querySelector ? root.querySelector('img') : null;
    return image ? (image.currentSrc || image.src || '') : '';
  }

  function priceFrom(root) {
    if (!root || !root.querySelector) return '';
    var node = root.querySelector('product-price, .price, .vda-home2-product__price');
    return node ? cleanText(node.textContent) : '';
  }

  function makeItem(root, link) {
    var url = link && link.href ? link.href : window.location.href;
    var titleNode = root.querySelector('[ref="productTitleLink"], .vda-home2-product__title, .resource-card__title, h3, .visually-hidden');
    var vendorNode = root.querySelector('.vda-home2-product__vendor');
    return normalizeItem({
      id: root.dataset ? (root.dataset.productId || '') : '',
      url: url,
      title: titleNode ? titleNode.textContent : '',
      image: imageFrom(root),
      price: priceFrom(root),
      vendor: vendorNode ? vendorNode.textContent : ''
    });
  }

  function createToggle(item, labeled, contextClass) {
    item = normalizeItem(item);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'vda-wishlist-toggle ' + (labeled ? 'vda-wishlist-toggle--product' : 'vda-wishlist-toggle--card');
    if (contextClass) button.classList.add(contextClass);
    button.dataset.wishlistKey = itemKey(item);
    button.dataset.wishlistTitle = item.title;
    button.setAttribute('aria-label', 'Save ' + item.title + ' to wishlist');
    button.setAttribute('aria-pressed', 'false');
    button.innerHTML = HEART + (labeled ? '<span class="vda-wishlist-label">Save</span>' : '');
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(item);
    });
    refreshSavedMetadata(item);
    return button;
  }

  function enhanceStandardCards() {
    document.querySelectorAll('product-card:not([data-vda-wishlist-ready])').forEach(function (card) {
      if (card.dataset.placeholder === 'true') return;
      var link = card.querySelector('a.product-card__link[href], a[href*="/products/"]');
      if (!link || !productHandle(link.href)) return;
      card.dataset.vdaWishlistReady = 'true';
      card.appendChild(createToggle(makeItem(card, link), false, 'vda-wishlist-toggle--standard-card'));
    });
  }

  function enhanceHomeCards() {
    document.querySelectorAll('a.vda-home2-product:not([data-vda-wishlist-ready])').forEach(function (link) {
      if (!productHandle(link.href)) return;
      link.dataset.vdaWishlistReady = 'true';
      var item = makeItem(link, link);
      var shell = document.createElement('div');
      shell.className = 'vda-wishlist-home-shell';
      shell.dataset.vdaWishlistManaged = 'true';
      link.parentNode.insertBefore(shell, link);
      shell.appendChild(link);
      shell.appendChild(createToggle(item, false, 'vda-wishlist-toggle--home-card'));
    });
  }

  function enhanceResourceCards() {
    document.querySelectorAll('.resource-card[data-resource-type="product"]:not([data-vda-wishlist-ready])').forEach(function (card) {
      var link = card.querySelector('a.resource-card__link[href], a[href*="/products/"]');
      if (!link || !productHandle(link.href)) return;
      card.dataset.vdaWishlistReady = 'true';
      card.appendChild(createToggle(makeItem(card, link), false, 'vda-wishlist-toggle--resource-card'));
    });
  }

  function productPageItem() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var url = canonical && canonical.href ? canonical.href : window.location.href;
    var titleMeta = document.querySelector('meta[property="og:title"]');
    var imageMeta = document.querySelector('meta[property="og:image"]');
    var title = titleMeta ? titleMeta.content : '';
    if (!title) {
      var heading = document.querySelector('.product-information h1, main h1');
      title = heading ? heading.textContent : document.title;
    }
    var productIdNode = document.querySelector('sticky-add-to-cart[data-product-id], .product-information [data-product-id]');
    return normalizeItem({
      id: productIdNode && productIdNode.dataset ? (productIdNode.dataset.productId || '') : '',
      url: url,
      title: title,
      image: imageMeta ? imageMeta.content : imageFrom(document.querySelector('.product-information') || document),
      price: priceFrom(document.querySelector('.product-information') || document)
    });
  }

  function enhanceProductPage() {
    if (!productHandle(window.location.href)) return;
    var details = document.querySelector('.product-information .product-details');
    if (!details || details.querySelector('.vda-wishlist-toggle--product')) return;

    var stack =
      details.querySelector(':scope > .group-block > .group-block-content') ||
      details.querySelector('.group-block-content');

    if (!stack) return;

    var button = createToggle(productPageItem(), true, '');
    button.dataset.vdaWishlistManaged = 'true';

    var first = stack.firstElementChild;
    if (first && first.nextSibling) stack.insertBefore(button, first.nextSibling);
    else stack.appendChild(button);
  }

  function setHeaderExpanded(expanded) {
    document.querySelectorAll('.vda-wishlist-header').forEach(function (button) {
      var next = expanded ? 'true' : 'false';
      if (button.getAttribute('aria-expanded') !== next) button.setAttribute('aria-expanded', next);
    });
  }

  function bindHeaderButtons() {
    document.querySelectorAll('.vda-wishlist-header:not([data-vda-wishlist-bound])').forEach(function (button) {
      button.dataset.vdaWishlistBound = 'true';
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', openDrawer);
    });
  }

  function ensureDrawer() {
    var existing = document.getElementById('vda-wishlist-dialog');
    if (existing) return existing;

    var dialog = document.createElement('dialog');
    dialog.id = 'vda-wishlist-dialog';
    dialog.className = 'vda-wishlist-dialog';
    dialog.dataset.vdaWishlistManaged = 'true';
    dialog.setAttribute('aria-labelledby', 'vda-wishlist-title');
    dialog.innerHTML =
      '<div class="vda-wishlist-panel">' +
        '<div class="vda-wishlist-drawer__header">' +
          '<div><p class="vda-wishlist-drawer__eyebrow">YOUR SAVED PIECES</p><h2 id="vda-wishlist-title">Wishlist</h2></div>' +
          '<button type="button" class="vda-wishlist-close" aria-label="Close wishlist">&times;</button>' +
        '</div>' +
        '<div class="vda-wishlist-list"></div>' +
      '</div>';

    document.body.appendChild(dialog);
    dialog.querySelector('.vda-wishlist-close').addEventListener('click', closeDrawer);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDrawer();
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDrawer();
    });
    return dialog;
  }

  function openDrawer() {
    var dialog = ensureDrawer();
    renderDrawer();
    document.documentElement.classList.add('vda-wishlist-open');
    document.body.classList.add('vda-wishlist-open');
    setHeaderExpanded(true);
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDrawer() {
    var dialog = document.getElementById('vda-wishlist-dialog');
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('vda-wishlist-open');
    document.body.classList.remove('vda-wishlist-open');
    setHeaderExpanded(false);
  }

  function renderDrawer() {
    var dialog = document.getElementById('vda-wishlist-dialog');
    if (!dialog) return;
    var list = dialog.querySelector('.vda-wishlist-list');
    if (!list) return;

    var fragment = document.createDocumentFragment();
    var items = readList();

    if (!items.length) {
      var empty = document.createElement('div');
      empty.className = 'vda-wishlist-empty';
      var emptyTitle = document.createElement('strong');
      emptyTitle.textContent = 'No saved pieces yet';
      var emptyText = document.createElement('p');
      emptyText.textContent = 'Tap the heart on any item and it will stay here for your next visit.';
      empty.appendChild(emptyTitle);
      empty.appendChild(emptyText);
      fragment.appendChild(empty);
    } else {
      items.forEach(function (item) {
        var key = itemKey(item);
        var row = document.createElement('div');
        row.className = 'vda-wishlist-item' + (item.image ? '' : ' vda-wishlist-item--no-image');

        var link = document.createElement('a');
        link.className = 'vda-wishlist-item__link';
        link.href = item.url || '#';

        if (item.image) {
          var imageWrap = document.createElement('div');
          imageWrap.className = 'vda-wishlist-item__media';
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || '';
          img.loading = 'lazy';
          imageWrap.appendChild(img);
          link.appendChild(imageWrap);
        }

        var copy = document.createElement('div');
        copy.className = 'vda-wishlist-item__copy';

        if (item.vendor) {
          var vendor = document.createElement('span');
          vendor.className = 'vda-wishlist-item__vendor';
          vendor.textContent = item.vendor;
          copy.appendChild(vendor);
        }

        var title = document.createElement('strong');
        title.className = 'vda-wishlist-item__title';
        title.textContent = item.title || 'Vintage piece';
        copy.appendChild(title);

        if (item.price) {
          var price = document.createElement('span');
          price.className = 'vda-wishlist-item__price';
          price.textContent = item.price;
          copy.appendChild(price);
        }

        link.appendChild(copy);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'vda-wishlist-item__remove';
        remove.setAttribute('aria-label', 'Remove ' + (item.title || 'item') + ' from wishlist');
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function () { removeItem(key); });

        row.appendChild(link);
        row.appendChild(remove);
        fragment.appendChild(row);
      });
    }

    list.replaceChildren(fragment);
  }

  function syncUi() {
    var items = readList();
    var keys = new Set(items.map(itemKey));

    document.querySelectorAll('.vda-wishlist-toggle[data-wishlist-key]').forEach(function (button) {
      var active = keys.has(button.dataset.wishlistKey);
      if (button.classList.contains('is-active') !== active) {
        button.classList.toggle('is-active', active);
      }
      var pressed = active ? 'true' : 'false';
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);

      var title = button.dataset.wishlistTitle || 'item';
      var aria = active ? ('Remove ' + title + ' from wishlist') : ('Save ' + title + ' to wishlist');
      if (button.getAttribute('aria-label') !== aria) button.setAttribute('aria-label', aria);

      var label = button.querySelector('.vda-wishlist-label');
      var nextLabel = active ? 'Saved' : 'Save';
      if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
    });

    document.querySelectorAll('.vda-wishlist-count').forEach(function (count) {
      var next = items.length ? String(items.length) : '';
      if (count.textContent !== next) count.textContent = next;
      var shouldHide = items.length === 0;
      if (count.hidden !== shouldHide) count.hidden = shouldHide;
    });
  }

  function showToast(message) {
    var toast = document.querySelector('.vda-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'vda-wishlist-toast';
      toast.dataset.vdaWishlistManaged = 'true';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    if (toast.textContent !== message) toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1800);
  }

  function enhance() {
    enhanceStandardCards();
    enhanceHomeCards();
    enhanceResourceCards();
    enhanceProductPage();
    bindHeaderButtons();
    ensureDrawer();
    syncUi();
  }

  function nodeNeedsEnhancement(node) {
    if (!(node instanceof Element)) return false;
    if (node.closest('[data-vda-wishlist-managed], #vda-wishlist-dialog, .vda-wishlist-header')) return false;
    if (node.matches('product-card, a.vda-home2-product, .resource-card[data-resource-type="product"], header-actions, .product-details')) return true;
    return !!node.querySelector('product-card, a.vda-home2-product, .resource-card[data-resource-type="product"], header-actions, .product-details');
  }

  function queueEnhance() {
    if (enhanceQueued) return;
    enhanceQueued = true;
    window.requestAnimationFrame(function () {
      enhanceQueued = false;
      enhance();
    });
  }

  function init() {
    readSyncState();
    deleteLegacyAccountCookie();
    purgeLegacyAccountCaches();
    migrateLegacyPendingAuthOperations();

    if (customerHint) {
      currentPendingAuthTarget();
      prepareAuthenticatedTransition();
    } else {
      prepareAnonymousView();
    }

    enhance();

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        if (mutation.target instanceof Element &&
            mutation.target.closest('[data-vda-wishlist-managed], #vda-wishlist-dialog, .vda-wishlist-header')) {
          return false;
        }
        return Array.prototype.some.call(mutation.addedNodes, nodeNeedsEnhancement);
      });
      if (relevant) queueEnhance();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) {
        localRevision += 1;
        syncUi();
        renderDrawer();
        scheduleAccountSync(150);
      }

      if (
        event.key === ACCOUNT_SYNC_STATE_KEY ||
        (event.key && event.key.indexOf(OPERATION_PREFIX) === 0)
      ) {
        localRevision += 1;
        scheduleAccountSync(150);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (
        customerHint &&
        document.visibilityState === 'visible' &&
        Date.now() - accountSync.lastSyncAt > 10000
      ) {
        scheduleAccountSync(100);
      }
    });

    window.addEventListener('focus', function () {
      if (
        customerHint &&
        Date.now() - accountSync.lastSyncAt > 10000
      ) {
        scheduleAccountSync(100);
      }
    });

    if (customerHint) {
      window.setTimeout(syncAccountWishlist, 0);
    }

    window.vdaWishlist = {
      open: openDrawer,
      items: readList,
      count: function () { return readList().length; },
      sync: syncAccountWishlist,
      accountSynced: function () { return accountSync.authenticated; }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();